import { render } from "./support_service.vue?vue&type=template&id=b4c56958"
import script from "./support_service.vue?vue&type=script&lang=js"
export * from "./support_service.vue?vue&type=script&lang=js"

import "./support_service.vue?vue&type=style&index=0&id=b4c56958&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__